import { InformationCircleIcon } from '@heroicons/react/24/outline';

import { cn } from '@/utils/tailwind';

export function InformationalBanner(props: {
  children: React.ReactNode;
  noIcon?: boolean;
  className?: string;
}) {
  return (
    <div
      className={cn(
        'mb-6 rounded-xl bg-secondary px-5 py-4',
        !props.noIcon && 'pl-8',
        props.className
      )}
    >
      <div className="flex items-center gap-6">
        {!props.noIcon && (
          <div className="relative h-5 w-5 rounded-[20px]">
            <div className="absolute left-[-4px] top-[-4px] h-7 w-7 rounded-3xl border-2 border-success opacity-30" />
            <div className="absolute left-[-9px] top-[-9px] h-[38px] w-[38px] rounded-3xl border-2 border-success opacity-10" />
            <div className="absolute left-0 top-0 h-5 w-5" />
            <InformationCircleIcon className="absolute left-0 top-0 h-5 w-5 stroke-brand-green-400" />
          </div>
        )}
        {props.children}
      </div>
    </div>
  );
}
